export default ($stateProvider) => {
  $stateProvider
    .state('wrapper.chat-session', {
      url: 'chat-session',
      params: {
        card: null,
      },
      template: '<nets-chat-sms-session card="$ctrl.card" context="compact"></nets-chat-sms-session>',
      controller: ['$stateParams', function ($stateParams) {
        this.card = $stateParams.card;
      }],
      controllerAs: '$ctrl',
    });
};
